import React from 'react'
import { SearchCollectionResult, SearchPageResult } from '../types/types'

type Props = {
  collectionResults?: SearchCollectionResult[] | null
  pageResults?: SearchPageResult[] | null
  searchTerm: string | null
}

function InstantCollectionOrPageResults({collectionResults, pageResults, searchTerm}: Props): JSX.Element | null { 
  const results = collectionResults || pageResults || null
  if (!results) {
    return null
  }

  const highLightText = (text: string, query: string | null): string | (string | JSX.Element)[] => {
    if (!query) {
      return text
    }
  
    const regex = new RegExp(`(${query})`, 'gi')
    const parts = text.split(regex)
  
    return parts.map((part, index) =>
      regex.test(part) ? <span key={index} className="text-black">{part}</span> : part
    )
  }

  // Only want to display 6 results. 
  const resultsToDisplay = results.slice(0,6)
  return (
    <div className='flex items-center flex-col mt-SM md:mt-[53px]'>
      {resultsToDisplay.map((result: any) => {
        if (result === null) {
          return null
        }
        const key = result.id
        const url = result.url
        const rootUrlWithoutSlash = window.routes.rootUrlWithoutSlash
        const urlWithLocale = !rootUrlWithoutSlash || (rootUrlWithoutSlash && url.includes(rootUrlWithoutSlash))
          ? url
          : rootUrlWithoutSlash + url

        const resultTitle = highLightText(result.name, searchTerm)
        return <a key={key} href={urlWithLocale} className='text-base-2 text-inactive-state uppercase mt-SM text-center'>{resultTitle}</a>
      })}
    </div>
  )
}

export default InstantCollectionOrPageResults